@if (item) {
  <div class="info-box-item" [style]="'background-color :'+ item.background">
    @if (item.icon) {
      <div class="icon">
        <cx-media [container]="item.icon"></cx-media>
      </div>
    }
    @switch (item.titleTag) {
      @case ('H1') {
        <h1 class="title">{{item.title}}</h1>
      }
      @case ('H2') {
        <h2 class="title">{{item.title}}</h2>
      }
      @default {
        <div  class="title">{{item.title}}</div>
      }
    }
    <div class="text">{{item.text}}</div>
    @if (item.urlButton && item.textButton) {
      <div class="more-info">
        <a [routerLink]="item.urlButton">
          {{item.textButton}}
        </a>
      </div>
    }
  </div>
}
